/* eslint-disable */
/**
 * Trust All Scripts
 *
 * This is a dirty little script for iterating over script tags
 * of your Ghost posts and adding them to the document head.
 *
 * This works for any script that then injects content into the page
 * via ids/classnames etc.
 *
 */
var trustAllScripts = function () {
	window.onload = function () {
		var scriptNodes = document.querySelectorAll('.load-external-scripts script');

		for (var i = 0; i < scriptNodes.length; i += 1) {
			var node = scriptNodes[i];
			var s = document.createElement('script');
			s.type = node.type || 'text/javascript';

			if (node.attributes.src) {
				s.src = node.attributes.src.value;
			} else {
				s.innerHTML = node.innerHTML;
			}
			node.remove();
			document.getElementsByTagName('body')[0].appendChild(s);
		}
	}
};

let fullViewportHeader = () => {
	let viewport = document.querySelector('.viewport')

	if (viewport && viewport.classList.contains('full')) {
		document.querySelector('.site-head').classList.add('site-head--transparent');
	}
}

// Load Moosend tracking script on client entry
exports.onClientEntry = function () {
	if (!window.mootrack && !document.getElementById('moosend-tracking')) {
		const script = document.createElement('script');
		script.id = 'moosend-tracking';
		script.type = 'text/javascript';
		script.innerHTML = `!function(t,n,e,o,a){function d(t){var n=~~(Date.now()/3e5),o=document.createElement(e);o.async=!0,o.src=t+"?ts="+n;var a=document.getElementsByTagName(e)[0];a.parentNode.insertBefore(o,a)}t.MooTrackerObject=a,t[a]=t[a]||function(){return t[a].q?void t[a].q.push(arguments):void(t[a].q=[arguments])},window.attachEvent?window.attachEvent("onload",d.bind(this,o)):window.addEventListener("load",d.bind(this,o),!1)}(window,document,"script","//cdn.stat-track.com/statics/moosend-tracking.min.js","mootrack");mootrack('init', 'dc90c5f7-129b-4b7c-8f50-d50019a21843');`;
		document.head.appendChild(script);
	}
};

exports.onRouteUpdate = function ({ location }) {
	trustAllScripts();
	fullViewportHeader();
	document.onload = fullViewportHeader();

	if (typeof window !== 'undefined' && location) {
		window.dataLayer = window.dataLayer || [];
		window.dataLayer.push({
			event: 'gatsby-route-change',
			pathname: location.pathname,
			page_path: location.pathname,
			page_location: location.href,
		});
	}
};
